import * as React from "react";
import styled from "styled-components";
import Heading from "../Heading";
import Checkbox, { Label } from "../Checkbox";
import Text from "../Text";
import defaultTheme from "../defaultTheme";
import { getSize } from "../Icon";
import { right } from "../utils/rtl";
import KEY_CODE_MAP from "../common/keyMaps";
var StyledListChoiceIcon = styled.div.withConfig({
  displayName: "ListChoice__StyledListChoiceIcon",
  componentId: "sc-1y53xes-0"
})(["display:flex;align-self:flex-start;flex:0 0 auto;margin-", ":", ";height:", ";svg{align-self:center;width:", ";height:", ";color:", ";transition:color ", " ease-in-out;}"], right, function (_ref) {
  var theme = _ref.theme;
  return theme.orbit.spaceSmall;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.orbit.lineHeightTextNormal;
}, getSize("small"), getSize("small"), function (_ref3) {
  var theme = _ref3.theme;
  return theme.orbit.colorIconPrimary;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.orbit.durationFast;
});
StyledListChoiceIcon.defaultProps = {
  theme: defaultTheme
};
var StyledListChoice = styled.div.withConfig({
  displayName: "ListChoice__StyledListChoice",
  componentId: "sc-1y53xes-1"
})(["display:flex;align-items:center;box-sizing:border-box;width:100%;padding:", ";border-bottom:1px solid ", ";background-color:", ";transition:background-color 0.15s ease-in-out;cursor:pointer;&:last-child{border:none;}&:focus,&:hover{background-color:", ";", " svg{color:", ";}outline:none;}", "{width:auto;}"], function (_ref5) {
  var theme = _ref5.theme;
  return "".concat(theme.orbit.spaceSmall, " ").concat(theme.orbit.spaceMedium);
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.orbit.paletteCloudNormal;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.orbit.paletteWhite;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.orbit.paletteCloudLight;
}, StyledListChoiceIcon, function (_ref9) {
  var theme = _ref9.theme;
  return theme.orbit.colorIconPrimary;
}, Label);
StyledListChoice.defaultProps = {
  theme: defaultTheme
};
var StyledListChoiceContent = styled.div.withConfig({
  displayName: "ListChoice__StyledListChoiceContent",
  componentId: "sc-1y53xes-2"
})(["display:flex;flex-direction:column;justify-content:center;width:100%;padding-", ":", ";"], right, function (_ref10) {
  var theme = _ref10.theme;
  return theme.orbit.spaceSmall;
});
StyledListChoiceContent.defaultProps = {
  theme: defaultTheme
};

var ListChoice = function ListChoice(props) {
  var dataTest = props.dataTest,
      icon = props.icon,
      title = props.title,
      description = props.description,
      selectable = props.selectable,
      onClick = props.onClick,
      selected = props.selected;

  var handleKeyDown = function handleKeyDown(ev) {
    if (onClick) {
      if (ev.keyCode === KEY_CODE_MAP.ENTER) {
        onClick(ev);
      } else if (ev.keyCode === KEY_CODE_MAP.SPACE) {
        ev.preventDefault();
        onClick(ev);
      }
    }
  };

  return React.createElement(StyledListChoice, {
    onClick: onClick,
    "data-test": dataTest,
    onKeyDown: handleKeyDown,
    tabIndex: "0",
    role: "button"
  }, icon && React.createElement(StyledListChoiceIcon, null, icon), React.createElement(StyledListChoiceContent, null, React.createElement(Heading, {
    type: "title4",
    element: "div"
  }, title), description && React.createElement(Text, {
    type: "secondary",
    size: "small"
  }, description)), selectable && React.createElement(Checkbox, {
    checked: selected,
    readOnly: true,
    tabIndex: "-1"
  }));
};

export default ListChoice;